// 대출원금 × 이자율 ÷ 12 × (1 + 이자율 ÷ 12)^기간 ÷ ((1 + 이자율 ÷ 12)^기간 -1)
export const getMonthly = (prc, advance, month, ratio) => {
	const price = (prc - advance) * 10000;
	const resultRatio = ratio || 0.043;
	// eslint-disable-next-line no-restricted-properties
	return Math.round((price * (resultRatio / 12) * Math.pow(1 + resultRatio / 12, month)) / (Math.pow(1 + resultRatio / 12, month) - 1));
};

export const calcInterest = (prepayAmount = 0, months, interestRate, carMaximumLimit) => {
	const prepayAmountUnit = 10000;
	const calculatedPrepayAmount = prepayAmount * prepayAmountUnit;

	const interestRateForYear = Number(interestRate / 12 / 100);
	const interestRatePowByMonths = (1 + interestRateForYear) ** months;
	const molecular = (carMaximumLimit - calculatedPrepayAmount) * interestRateForYear * interestRatePowByMonths;
	const denominator = interestRatePowByMonths - 1;

	return Math.round(molecular / denominator);
};

/**
 * 금리 낮은 순 최대 3개 금융사 필터링 (현대캐피탈 필수 포함)
 * @param {Array<{financialCompany: string, financialCompanyName: string, interestRate: number}>} interestInfo
 * @returns {Array}
 */
export const filterInterestInfo = (interestInfo) => {
	const MAX_COUNT = 3;
	const REQUIRED_COMPANY = 'HYUNDAICAPITAL';
	const sortedByRate = [...interestInfo].sort((a, b) => a.interestRate - b.interestRate);
	const lowestRates = sortedByRate.slice(0, MAX_COUNT);

	if (lowestRates.some((item) => item.financialCompany === REQUIRED_COMPANY)) return lowestRates;

	const requiredItem = sortedByRate.find((item) => item.financialCompany === REQUIRED_COMPANY);
	if (!requiredItem) return lowestRates;

	return [...lowestRates.slice(0, MAX_COUNT - 1), requiredItem].sort((a, b) => a.interestRate - b.interestRate);
};

export default null;
